import { PiggyBankIcon } from "@phosphor-icons/react";

import type { CarouselSlide } from "@alpacahq/ui/old";

export interface IraSlideProps {
  onApply: () => void;
}

export const iraSlide = ({ onApply }: IraSlideProps): CarouselSlide => ({
  id: "ira",
  title: <h2 className="m-0 font-semibold text-gray-800">IRA Accounts</h2>,
  description: (
    <span className="text-gray-700 text-sm">
      API trading is now available in IRA accounts — grow your retirement with
      tax advantages and automation.
    </span>
  ),
  icon: <PiggyBankIcon size={24} />,
  // @TODO: Add learn more link when blog post is published
  // learnMoreLink: "",
  button: {
    label: "Apply Now",
    onClick: onApply,
  },
});
